import { render } from "./CountersPage.vue?vue&type=template&id=6025f732"
import script from "./CountersPage.vue?vue&type=script&lang=js"
export * from "./CountersPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__